
riot.tag2('toaster', '<div each="{slices}" class="toast-slice toast-{type} {transition}"><a onclick="{parent.close}" class="toast-close">&times;</a> <h3>{title}</h3> <p> {message}<span if="{count&gt;1}"></span> </p> </div>', 'toaster { position: fixed; top: 0px; right: 10px; z-index: 10000; } @media screen and (min-device-width: 360px) and (max-device-width: 568px) { toaster { left: 10px; } } toaster .toast-slice { position: relative; background: #444; width: 280px; color: #fff; padding: 15px; border-radius: 4px; -webkit-box-shadow: 0 4px 10px rgba(0,0,0,0.3); box-shadow: 0 4px 10px rgba(0,0,0,0.3); margin-top: 10px; -webkit-animation: open-animation 0.3s linear forwards; -moz-animation: open-animation 0.3s linear forwards; -o-animation: open-animation 0.3s linear forwards; -ms-animation: open-animation 0.3s linear forwards; animation: open-animation 0.3s linear forwards; } @media screen and (min-device-width: 360px) and (max-device-width: 568px) { toaster .toast-slice { width: auto; } } toaster .toast-slice h3 { margin: 0 20px 5px 0; font-size: 18px; } toaster .toast-slice a.toast-close { position: absolute; top: 5px; right: 10px; color: #fff; opacity: 0.7; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)"; filter: alpha(opacity=70); } toaster .toast-slice a.toast-close:hover { opacity: 1; -ms-filter: none; filter: none; text-decoration: none; } toaster .toast-out { -webkit-animation: close-animation 0.3s linear forwards; -moz-animation: close-animation 0.3s linear forwards; -o-animation: close-animation 0.3s linear forwards; -ms-animation: close-animation 0.3s linear forwards; animation: close-animation 0.3s linear forwards; } toaster .toast-info { background-color: #2f96b4; } toaster .toast-warning { background-color: #f89406; } toaster .toast-success { background-color: #51a351; } toaster .toast-error { background-color: #bd362f; } @-moz-keyframes open-animation { from { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); max-height: 0; padding: 0 15px; } to { opacity: 1; -ms-filter: none; filter: none; padding: 15px; max-height: 400px; } } @-webkit-keyframes open-animation { from { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); max-height: 0; padding: 0 15px; } to { opacity: 1; -ms-filter: none; filter: none; padding: 15px; max-height: 400px; } } @-o-keyframes open-animation { from { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); max-height: 0; padding: 0 15px; } to { opacity: 1; -ms-filter: none; filter: none; padding: 15px; max-height: 400px; } } @keyframes open-animation { from { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); max-height: 0; padding: 0 15px; } to { opacity: 1; -ms-filter: none; filter: none; padding: 15px; max-height: 400px; } } @-moz-keyframes close-animation { from { opacity: 1; -ms-filter: none; filter: none; max-height: 400px; padding: 15px; } to { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); padding: 0 15px; max-height: 0; } } @-webkit-keyframes close-animation { from { opacity: 1; -ms-filter: none; filter: none; max-height: 400px; padding: 15px; } to { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); padding: 0 15px; max-height: 0; } } @-o-keyframes close-animation { from { opacity: 1; -ms-filter: none; filter: none; max-height: 400px; padding: 15px; } to { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); padding: 0 15px; max-height: 0; } } @keyframes close-animation { from { opacity: 1; -ms-filter: none; filter: none; max-height: 400px; padding: 15px; } to { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); padding: 0 15px; max-height: 0; } }', '', function(opts) {
this.handleChange = (function(_this) {
  return function(slices) {
    _this.slices = slices;
    return _this.update();
  };
})(this);

this.on('mount', function() {
  this.slices = [];
  return this.root.trigger = this.trigger;
});

this.close = (function(_this) {
  return function(event) {
    return _this.remove(event.item);
  };
})(this);

this.on('add', function(slice) {
  var dupes;
  dupes = this.slices.filter(function(s) {
    return s.message === slice.message;
  });
  if (this.slices.length === 0 || dupes.length === 0) {
    slice.transition = "toast-in";
    if (slice.title == null) {
      slice.title = "";
    }
    if (slice.message == null) {
      slice.message = "";
    }
    if (slice.type == null) {
      slice.type = "info";
    }
    if (slice.timeOut == null) {
      slice.timeOut = 5;
    }
    this.slices.unshift(slice);
  }
  this.update();
  if (slice.timeOut) {
    return setTimeout((function(_this) {
      return function() {
        var lastSlice;
        lastSlice = _this.slices[_this.slices.length - 1];
        return _this.remove(lastSlice);
      };
    })(this), slice.timeOut * 1000);
  }
});

this.remove = (function(_this) {
  return function(item, timeOut) {
    var index;
    if (timeOut == null) {
      timeOut = 500;
    }
    index = _this.slices.indexOf(item);
    if (index < 0) {
      return;
    }
    _this.slices[index].transition = 'toast-out';
    _this.update();
    return (function(item) {
      return setTimeout(function() {
        index = _this.slices.indexOf(item);
        _this.slices.splice(index, 1);
        return _this.update();
      }, timeOut);
    })(item);
  };
})(this);
});